import { SearchableSelectOption } from '../components/SearchableSelect';

export function toOptions<T>(
  items: T[] | undefined,
  getValue: (item: T) => string,
  getLabel?: (item: T) => string,
  sortLabels = true
): SearchableSelectOption[] {
  if (!items) return [];

  const opts = items
    .map((item) => {
      const value = getValue(item);
      const label = getLabel ? getLabel(item) : value;
      return value ? { value, label } : null;
    })
    .filter((x): x is SearchableSelectOption => !!x);

  if (sortLabels) {
    opts.sort((a, b) => a.label.localeCompare(b.label));
  }

  return opts;
}

export function uniqueOptions(values: (string | null | undefined)[]) {
  return Array.from(new Set(values.filter((v): v is string => !!v))).map(
    (value) => ({ value, label: value })
  );
}
